import React from 'react';
import { CloseableModal } from '../../../../../../../components/CloseableModal';
import { ModalBody } from '../../../../../../CandidatePage/CandidateActions/RejectCandidate/ModalBody';
import { AlertMessage } from '../../../../../../../components/AlertMessage';
import { BulkProgress } from '../../../../../../../hooks/useBulkAction';
import { BulkProgressBody } from '../../../../../../../components/BulkProgressBody';

interface PropTypes {
  applicationIds: number[];
  selectionCountLabel: string;
  warningDescription?: string;
  progress?: BulkProgress | null;
  onBulkReject?: (rejectReasonId: number) => Promise<void>;
  onClose: (succeeded?: boolean) => void;
}

export function BulkRejectModal(props: PropTypes) {
  const isProcessing = props.progress != null;

  return (
    <CloseableModal
      className='modal-dialog-centered'
      onClose={() => props.onClose(null)}
      isOpen={true}
      size='md'
      closeDisabled={isProcessing}
      keyboard={!isProcessing}
      backdrop={isProcessing ? 'static' : true}
      headerTitle='Reject Candidate'
      bodyChildren={
        isProcessing ? (
          <BulkProgressBody {...props.progress} actionLabel='rejections' />
        ) : (
          <>
            {props.warningDescription && (
              <AlertMessage
                hasOverlay={false}
                icon={{ name: 'bi-info-circle' }}
                className='mb-4 mt-0 fs-5 bg-yellow-light'
                text={<span>{props.warningDescription}</span>}
              />
            )}
            <ModalBody
              applicationIds={props.applicationIds}
              description={
                <>
                  Are you sure you want to reject{' '}
                  {props.applicationIds.length > 1 ? 'these ' : 'this '}
                  {props.selectionCountLabel}?
                </>
              }
              onBulkReject={props.onBulkReject}
              onClose={props.onClose}
            />
          </>
        )
      }
    />
  );
}
